import { ReactNode } from "react";

export const HelperText = (props: { text?: string | ReactNode }) => {
    const { text } = props;

    if (!text) {
        return null;
    }

    return (
        <div>
            <small className="text-body-secondary">{text}</small>
        </div>
    );
};
